export default __webpack_public_path__ + "static/media/estacion-omnibus.66861b27.svg";